/**
 * 연결된 계정(다른 loginId) 전환 시 사용할 액세스/리프레시 토큰을 계정별로 보관합니다.
 * "다른 계정 추가" 시 해당 계정으로 로그인해 얻은 토큰을 저장해 두었다가 전환 시 복원합니다.
 */
const STORAGE_KEY = 'medicrew_linked_account_sessions';

export type LinkedAccountTokens = {
	accessToken: string;
	/** 있으면 토큰 갱신에 사용. 없으면 access 만료 시 재로그인 */
	refreshToken?: string;
};

export function readLinkedAccountSessions(): Record<string, LinkedAccountTokens> {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		if (!raw) return {};
		const parsed = JSON.parse(raw) as unknown;
		if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
			return parsed as Record<string, LinkedAccountTokens>;
		}
		return {};
	} catch {
		return {};
	}
}

function writeLinkedAccountSessions(sessions: Record<string, LinkedAccountTokens>): void {
	localStorage.setItem(STORAGE_KEY, JSON.stringify(sessions));
}

/** 현재 계정 id 기준으로 토큰 스냅샷 저장 (로그인 응답의 accessToken 필수) */
export function saveLinkedAccountSession(accountId: string, tokens: LinkedAccountTokens): void {
	if (!accountId || !tokens.accessToken?.trim()) return;
	const all = readLinkedAccountSessions();
	const entry: LinkedAccountTokens = {
		accessToken: tokens.accessToken.trim(),
		...(tokens.refreshToken?.trim() ? { refreshToken: tokens.refreshToken.trim() } : {}),
	};
	all[accountId] = entry;
	writeLinkedAccountSessions(all);
}

export function loadLinkedAccountSession(accountId: string): LinkedAccountTokens | null {
	const all = readLinkedAccountSessions();
	const t = all[accountId];
	if (t?.accessToken?.trim()) return t;
	return null;
}

export function removeLinkedAccountSession(accountId: string): void {
	const all = readLinkedAccountSessions();
	delete all[accountId];
	writeLinkedAccountSessions(all);
}

export function clearLinkedAccountSessions(): void {
	localStorage.removeItem(STORAGE_KEY);
}
